import React from 'react'
import '../Routes/Projectawarded.css'
 import MegaNavbar from '../Components/MegaNavbar'
import Footer from '../Components/Footer'
 

const Projectawarded = () => {
  return (
    <>
    <MegaNavbar/>
    {/* <!- 1 Department of Zoology --> */}
    <div class="table-container container">
      <h3 className='th1'> Department of Zoology</h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                    <th>Date/Year of the Project Awarded</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td> Green synthesis of gold nanoparticles
                         by using extracts 
                      of Colchicum luteum, their 
                      characterization and evaluation</td>
                    <td> Dr Madiha Iqbal, IPFP Fellow, Dept. Of Zoology</td>
                    <td>0.90944</td>
                    <td>01 Year</td>
                    <td>SRGP</td>
                    <td>22-04-2021</td>
                 
                </tr>
                <tr>
                    <td>2</td>
                    <td>Biological Activities assessment, Phytochemical Screening and 
                      Artemisinin Quantification
                       of Artemisia persica Boiss. 
                       Collected from North Western Hills of Pakistan</td>
                    <td>Dr. Faiza Tawab, IPFP Fellow, Dept. Of Zoology</td>
                    <td>0.9148</td>
                    <td>01 Year</td>
                    <td>SRGP</td>
                    <td>22-04-2021</td>
                    
                </tr>
                <tr>
                    <td>3</td>
                    <td>Epidemiology of malaria in District Peshawar; comparing performance of different diagnostic techniques</td>
                    <td>PI: Dr. Fatima Jahan (Zoology)
                      Co PI Dr. Rabea Ejaz (Zoology)</td>

                    <td>1</td>
                    <td>01 Year</td>
                    <td>SRGP</td>
                    
                    <td>12-04-2021</td>
                    
                </tr>
                <tr>
                    <td>4</td>
                    <td>Gynecological Management and Herbal Treatment of Neuropathic pain and neuralagia of the Uterus</td>
                    <td>PI: Dr. Irum Maqsood, Assistant Professor</td>

                    <td>0.3</td>
                    <td>01 Year</td>
                    <td>SBBWURG</td>
                    
                    <td>20-01-2021</td>
                    
                </tr>
                {/* <!-- 2 Department of English--> */}
                
            </tbody>
        </table>
      <h3 className='th1'> Department of English</h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                    
                    <th>Date/Year of the Project Awarded</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>“Bringing Pakistani Literature to Life: Creation of Animated videos, games and short film”</td>
                    <td>Dr. Anbarin Fatima, Assistant Professor, Dept. of English</td>
                    <td>1.8375</td>
                    <td>03 Years</td>
                    <td>NRPU</td>
                
                    <td>10-12-2021</td>
                 
                </tr>
                <tr>
                    <td>2</td>
                    <td>PK-UK Higher Education Links (Pakistan/UK, Celebrating 75) with the Shakespeare Institute University of Birmingham UK</td>
                    <td>Ms. Henna Karamat, Assistant Professor, Dept. of English</td>
                    <td>1.8679</td>
                    <td>01 Year</td>
                    <td>British Council</td>
    
                    <td>11-03-2022</td>
                    
                </tr>
                <tr>
                    <td>3</td>
                    <td>English Works! Program</td>
                    <td>Ms. Beenish Asmatullah</td>

                    <td>$ 0.155286</td>
                    <td>7 months</td>
                    <td>U.S Department of State</td>
                
                    <td>Nov 2021</td>
                    
                </tr>
                <tr>
                    <td>4</td>
                    <td>English Works! Program</td>
                    <td>Ms. Beenish Asmatullah</td>

                    <td>24.6</td>
                    <td>7 months</td>
                    <td>U.S Department of State</td>
                    
                    <td>July 2022</td>
                    
                </tr>
                {/* <!- 3 Department of Biochemistry --> */}
                
            </tbody>
        </table>
      <h3 className='th1'> Department of Biochemistry</h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                    
                    <th>Date/Year of the Project Awarded</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Skills for all under Kamyab Jawan Program</td>
                    <td>Dr. Rehana Masood, Assistant professor, Dept. of Biochemistry</td>
                    <td>2.4373</td>
                    <td>6 months</td>
                    <td>NAVTTC</td>
                    
                    <td>15-01-2022</td>
                 
                </tr>
                <tr>
                    <td>2</td>
                    <td>Single batch desizing, bleaching and bioscouring of cotton fabric: Eco-friendly and green solution for textile processing</td>
                    <td>Dr. Sidra Pervez, Assistant Professor, Dept. of Biochemistry</td>
                    <td>3.45345</td>
                    <td>03 Years</td>
                    <td>NRPU</td>
                    
                    <td>11-03-2022</td>
                    
                </tr>
                <tr>
                    <td>3</td>
                    <td>Construction of photobioreactor for algal cultivation: An approach towards ecofriendly wastewater treatment</td>
                    <td>Dr. Sidra Pervez, Assistant Professor, Dept. of Biochemistry</td>

                    <td>0.6</td>
                    <td>01 Year</td>
                    <td>DoST</td>
                    
                    <td>05-04-2023</td>
                    
                </tr>
                <tr>
                    <td>4</td>
                    <td>Endophytic fungi from a medical plant withania coagulans, a potential source of bioactive metabolites</td>
                    <td>Dr. Rehana Masood, Assistant professor, Dept. of Biochemistry</td>

                    <td>24.6</td>
                    <td>0.6</td>
                    <td>DoST</td>
                    
                    <td>05-04-2023</td>
                    
                </tr>
                {/* <!-- 4 Department of BioInformatics and Computer Science --> */}
                

            </tbody>
        </table>
      <h3 className='th1'> Department of BioInformatics and Computer Science</h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                
                    <th>Date/Year of the Project Awarded</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Going Global Partnership-STEM Undergraduate Education Program</td>
                    <td>1. Dr. Farhat Amin, Associate Professor, Dept. of Bio-informatics<br/>
                    2. Dr. Neelam Gohar, Assistant Professor, Dept. of Computer Science
                    </td>
                    <td>4.738318</td>
                    <td>01 Years</td>
                    <td>British Council</td>
                    
                    <td>13-12-2021</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>Digital Preservation and Interlinking of KPK’s Cultural Heritage Resources: (phase 1)</td>
                    <td>Dr. Salma Noor, Assistant Professor, Department of Computer Science, SBBWU</td>
                    <td>0.3</td>
                    <td>03 Year</td>
                    <td>NRPU</td>
                    <td> </td>
                    
                </tr>
                <tr>
                    <td>3</td>
                    <td>Biosynthesis,characterization and evaluation of bioactivities of fruit extract mediated biocompatible silver and gold nanoparticles from Monotheca buxifolia</td>
                    <td>Dr.Aishma Khattak Assistant Professor Department of Bioinformatics </td>
                    <td>1.5</td>
                    <td>05 Year</td>
                    <td>SRGP</td>
                    <td>05-06-2020</td>
                    
                </tr>
                <tr>
                    <td>4</td>
                    <td>Development of Molecular diagnostic tool for the detection of COVID-19 using immuno-informatics approach</td>
                    <td>Dr. Farhat Ameen, Associate Professor, Department of Bio-Informatics</td>
                    <td>0.3</td>
                    <td>01 Year</td>
                    <td>SBBWURG</td>
    
                    <td>20-01-2021</td>
                    
                </tr>
                <tr>
                    <td>5</td>
                    <td>Exp;oiting google tools for intruders and crime scence detection</td>
                    <td>Dr. Fouzia Jabeen, Assistant Professor, Department of Computer Science</td>
                    <td>0.05</td>
                    <td>01 year</td>
                    <td>KEIDO</td>
                    
                    <td>19-01-2021</td>
                    
                </tr>
                <tr>
                    <td>6</td>
                    <td>Secre and reliable online transport services for students of educational institutes</td>
                    <td>Dr. Nasreen Anjum, Assistant Professor, Department of Computer Science</td>
                    <td>0.5</td>
                    <td>01 Year</td>
                    <td>KEIDO</td>
                    
                    <td>19-01-2021</td>
                    
                </tr>
                <tr>
                    <td>7</td>
                    <td>Wedding bells-the online wedding hall booking interface</td>
                    <td>Dr. Neelam Gohar, Assistant Professor, Department of Computer Science</td>
                    <td>0.5</td>
                    <td>01 Year</td>
                    <td>KEIDO</td>
                    
                    <td>19-01-2021</td>
                    
                </tr>
                <tr>
                    <td>8</td>
                    <td>Online Salon booking App</td>
                    <td>Dr. Neelam Gohar, Assistant Professor, Department of Computer Science</td>
                    <td>0.05</td>
                    <td>01 Year</td>
                    <td>KEIDO</td>
                
                    <td>19-01-2021</td>
                </tr>
                <tr>
                    <td>9</td>
                    <td>Mend-the online marketplace for repairing service</td>
                    <td>Dr. Neelam Gohar, Assistant Professor, Department of Computer Science</td>
                    <td>0.05</td>
                    <td>01 Year</td>
                    <td>KEIDO</td>
                    
                    <td>19-01-2021</td>
                    
                </tr>
               
                {/* <!-- 5 Department of Chemistry --> */}
                
            </tbody>
        </table>
      <h3 className='th1'> Department of Chemistry</h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                    
                    <th>Date/Year of the Project Awarded</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Standardization, Characterization, and safety evaluation of commonly used  Pakistani herbal medicinal plants and their formulations</td>
                    <td>Dr. Nargis Jamila, Assistant Professor, Dept. of Chemistry</td>
                    <td>6.492693</td>
                    <td>03 Years</td>
                    <td>NRPU</td>
                
                    <td>27-03-2019</td>
                 
                </tr>
                <tr>
                    <td>2</td>
                    <td>Institutional Strengthening Grant for upgrading laboratories & Libraries</td>
                    <td>Dr. Rozina Khattak</td>
                    <td>2.87210</td>
                    <td>01 Year</td>
                    <td>HEC</td>
                    <td></td>
                    
                    
                </tr>
                <tr>
                    <td>3</td>
                    <td>Enhancement of Shelf Life of Fruits and Vegetables using Coating of Local Plants</td>
                    <td>Dr. Nargis Jamila, Assistant Professor, Dept. of Chemistry</td>
                    <td>0.6</td>
                    <td>01 year</td>
                    <td>DoST</td>
                    <td>05-04-2023</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>High Performance Liquid Chromotograpohy</td>
                    <td>Dr. Nargis Jamila, Assistant Professor, Dept. of Chemistry</td>

                    <td>0.35</td>
                    <td>01 year</td>
                    <td>DoST</td>
                
                    <td>08-08-2023</td>
                    
                </tr>
                <tr>
                    <td>5</td>
                    <td>Removal of waste-antibiotics from drinking water by Polymer Enhanced </td>
                    <td>Dr. Fatima Javed, Assistant Professor, Department of Chrmistry</td>

                    <td>0.28</td>
                    <td>01 year</td>
                    <td>SBBWURG</td>
                
                    <td>20-01-2021</td>
                    
                </tr>
                <tr>
                    <td>6</td>
                    <td> Synthesis and characterization of activated carbon for water purification via adsorption technique using stone fruit and berries seeds  </td>
                    <td>Dr. Aliya Minhas, Assistant Professor, Department of Chemistry</td>

                    <td>0.3</td>
                    <td>01 year</td>
                    <td>SBBWURG</td>
                
                    <td>20-01-2021</td>
                    
                </tr>
                <tr>
                    <td>7</td>
                    <td>Development, Characterization, and Assessment of Hair Care Products Using Local Herbs and Mushrooms</td>
                    <td>Dr. Nargis Jamila, Assistant Professor, Department of Chemistry</td>

                    <td>0.5</td>
                    <td>01 year</td>
                    <td>SBBWURG</td>
                
                    <td>20-01-2021</td>
                    
                </tr>
                <tr>
                    <td>8</td>
                    <td>Formulation, characterization, antioxidant and anti-aging activities evaluation of polyherbal anti-aging products using local medicinal herbs and mushrooms </td>
                    <td>Dr. Nargis Jamila, Assistant Professor, Department of Chemistry</td>

                    <td>0.3</td>
                    <td>01 year</td>
                    <td>SBBWURG</td>
                
                    <td>20-01-2021</td>
                    
                </tr>
                {/* <!--6  Department of History --> */}
                
            </tbody>
        </table>
      <h3 className='th1'> Department of History</h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                    <th>Status</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Contribution of Pashtu Poetry for the Promotion of Peace and Harmony.</td>
                    <td>Prof. Dr. Razia Sultana</td>
                    <td>4.0</td>
                    <td>01 Years</td>
                    <td>HEC</td>
                    <td>Completed</td>
                 
                </tr>
                <tr>
                    <td>2</td>
                    <td>Changing Dynamics of Politics in kpk 1947-2010.</td>
                    <td>Prof. Dr. Razia Sultana</td>
                    <td>5.7</td>
                    <td>12 Months</td>
                    <td>NRPU</td>
                    <td>Completed</td>
                    
                </tr>
               
                {/* <!-- 7 Department of Law --> */}
                
            </tbody>
        </table>
      <h3 className='th1'> Department of Law</h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                    <th>Status</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Training under Pakistan Legal Education Support Program</td>
                    <td>Ms. Arzoo Farhad, Department of Law</td>
                    <td>$ 7.7</td>
                    <td>02 Years</td>
                    <td>International</td>
                    <td>Completed</td>
                 
                </tr>
               
                {/* <!-- 9 Department of Psychology --> */}
                
            </tbody>
        </table>
      <h3 className='th1'> Department of Psychology </h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                    <th>Status</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>University partnership between Southern Methodist University (SMU) and the department of Psychology at Shaheed Benazir Bhutto Women University (SBBWU) in Peshawar, Pakistan. Support the enhancement of the Department of Psychology at SBBWU through 1. Faculty training 2. Curriculum Development 3. Research; and 4. Clinic Capacity</td>
                    <td>Dr. Kalsoom</td>
                    <td>7</td>
                    <td>01 Years</td>
                    <td>International</td>
                    <td>Completed</td>
                 
                </tr>
               
                {/* <!-- 10 Department of Economics--> */}
                
            </tbody>
        </table>
      <h3 className='th1'> Department of  Economics </h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                    <th>Status</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Effect of Inflation over the Economic Growth of Pakistan </td>
                    <td>Dr. Fariha Sami, Assistant Professor, Department of Economics</td>
                    <td>0.3</td>
                    <td>01 Years</td>
                    <td>SBBWURG</td>
                    <td>20-01-2-2021</td>
                 
                </tr>
               
                {/* <!-- 11 Department of Urdu --> */}
                
            </tbody>
        </table>
      <h3 className='th1'> Department of  Urdu </h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                    <th>Status</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td> کرونا وائرس کے تناظر میں لکھی گئی شاعری کا نفسیاتی تجزیہ</td>
                    <td>Dr. Raheela Khurshid, Department of Urdu</td>
                    <td>0.749</td>
                    <td>01 Years</td>
                    <td>SBBWURG</td>
                    <td>20-01-2021</td>
                 
                </tr>
               
                {/* <!-- 12 Department of Political Science --> */}
                
            </tbody>
        </table>
      <h3 className='th1'> Department of Political Science </h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                    <th>Status</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Role of Civil Society Organizations in Climate Change Adaptation in Khyber Pakhtunkhwa</td>
                    <td>Dr. Sadaf Bashir, Assistant Professor, Department of Political Science</td>
                    <td>0.5</td>
                    <td>01 Years</td>
                    <td>SBBWURG</td>
                    <td>20-01-2021</td>
                 
                </tr>
               
                {/* <!-- 13 Department of Islamiyat --> */}
                
            </tbody>
        </table>
      <h3 className='th1'> Department of Islamiyat </h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                    <th>Status</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>We are Better Together (Impact of Harmonizing Interfaith Difference on Pakistan)</td>
                    <td>Dr. Nasim Akhter, Pro-Vice Chancellor, Department of Islamiyat</td>
                    <td>0.5</td>
                    <td>01 Years</td>
                    <td>SBBWURG</td>
                    <td>20-01-2021</td>
                 
                </tr>
               
                {/* <!-- 14 Statistic--> */}
                
            </tbody>
        </table>
      <h3 className='th1'> Department of Statistic </h3>
        <table class="responsive-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Project Title</th>
                    <th>Principal Investigator</th>
                    <th>Total Funding in Millions (M)</th>
                    <th>Duration</th>
                    <th>Donor/Funding Source</th>
                   
                    
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>Gap Analysis to Bridge Academia, Research and Industry to Achieve Economically Sustainable Growth”</td>
                    <td>Dr. Asma Gul Department of Statistics</td>
                    <td>1.91</td>
                    <td>01 Years</td>
                    <td>HEC</td>
                    
                 
                </tr>
               
                {/* <!-- More rows as needed --> */}
                
            </tbody>
        </table>
    </div>

<Footer/>
    
    </>
  )
}

export default Projectawarded